import React, { useSyncExternalStore } from 'react';
import { EyeOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const CLE = 'ftpe_bloc_masque';
const CLE_MOTIF = 'ftpe_bloc_motif';
export const MOTIFS_FTPE = { deja_adherent: 'Déjà adhérent', adhesion_ulterieure: 'Adhésion ultérieure' };
const EVT = 'ftpe-bloc-masque';
const lire = () => sessionStorage.getItem(CLE) === '1' && !!MOTIFS_FTPE[sessionStorage.getItem(CLE_MOTIF)];
const lireMotif = () => sessionStorage.getItem(CLE_MOTIF) || '';
/** Motif en cours si le bloc est masqué (contrôlé côté serveur : super admin uniquement). */
export const motifFtpeActif = () => (lire() ? lireMotif() : null);
const abonner = (cb) => { window.addEventListener(EVT, cb); return () => window.removeEventListener(EVT, cb); };

/** Super admin : masque le bloc « Adhésion partenaire » (200 €) dans les simulateurs pour la session en cours. */
export const useFtpeMasque = () => {
  const masque = useSyncExternalStore(abonner, lire);
  const motif = useSyncExternalStore(abonner, lireMotif);
  const set = (v, m) => {
    sessionStorage.setItem(CLE, v ? '1' : '0');
    if (m !== undefined) sessionStorage.setItem(CLE_MOTIF, m);
    window.dispatchEvent(new Event(EVT));
  };
  return [masque, set, motif];
};

export const estSuperAdmin = (user) => String(user?.role || '').toLowerCase() === 'super_admin';

export default function FtpeMasqueToggle() {
  const { user } = useAuth();
  const [masque, setMasque, motif] = useFtpeMasque();
  const [demande, setDemande] = React.useState(false);
  if (!estSuperAdmin(user)) return null;
  const cocher = (v) => { if (v) setDemande(true); else { setDemande(false); setMasque(false, ''); } };
  return (
    <div className="space-y-1.5 rounded-lg border border-dashed border-amber-400 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800" data-testid="ftpe-masque-toggle">
      <label className="flex cursor-pointer items-center gap-2">
        <input type="checkbox" checked={masque || demande} onChange={(e) => cocher(e.target.checked)} className="h-4 w-4 accent-amber-600" data-testid="ftpe-masque-checkbox" />
        <EyeOff className="h-3.5 w-3.5" /> Super Admin — désactiver le bloc Adhésion partenaire (200 €) : écran, total et devis
      </label>
      {(masque || demande) && (
        <div className="flex flex-wrap items-center gap-2 pl-6">
          <span>Motif :</span>
          <select value={masque ? motif : ''} onChange={(e) => { setMasque(!!e.target.value, e.target.value); setDemande(!e.target.value); }}
            className="rounded border border-amber-300 bg-white px-2 py-1 text-xs font-normal text-slate-700" data-testid="ftpe-masque-motif">
            <option value="">Choisir un motif…</option>
            {Object.entries(MOTIFS_FTPE).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          {!masque && <span className="font-normal text-amber-700">Le bloc reste affiché tant qu'aucun motif n'est choisi.</span>}
        </div>
      )}
    </div>
  );
}
